<template>
  <header><img src="https://www.dmm.com/images/netgame/navi/dmm_logo.gif" alt="DMM.com"></header>
</template>

<script>
    export default {
        name: "dmmnavi_header"
    }
</script>

<style lang="scss" scoped>
  header {
    text-align: left;
    padding: pxTorem(12px) pxTorem(10px);
    border-bottom: #ccc 1px solid;
    background: #fff;
    line-height: 0;
    display: none;

    @media screen and (max-width: 600px) {
      display: block;
    }

  }
</style>
